import {
  Button,
  Flex,
  Popover,
  PopoverArrow,
  PopoverCloseButton,
  PopoverContent,
  PopoverHeader,
  PopoverTrigger,
  Portal,
  useMediaQuery,
} from "@chakra-ui/react";
import React from "react";
import { PopoverBody } from "react-bootstrap";
import { IoIosArrowDown, IoIosArrowUp } from "react-icons/io";
import { Link } from "react-router-dom";

const ComponentCenterListMenu = ({ menufilho, menupai }) => {
  const [isLargerThan1366] = useMediaQuery("(min-width: 1366px)");

  return (
    <>
      {menupai.map((item, idx) => {
        idx = idx++;
        if (item != "Home") {
          return (
            <Popover placement="bottom" isLazy key={idx}>
              {({ isOpen, onOpen, onClose }) => (
                <>
                  <PopoverTrigger
                  >
                    <Button
                      rightIcon={isOpen ? <IoIosArrowUp /> : <IoIosArrowDown />}
                      fontSize={isLargerThan1366 ? "1rem" : ".9rem"}
                      variant="ghost"
                      colorScheme="blue"
                      size="sm"
                      _hover={{ color: "blue.500" }}
                      _focus={{ boxShadow: "none" }}
                    >
                      {item}
                    </Button>
                  </PopoverTrigger>
                  <Portal>
                    <PopoverContent
                      onMouseLeave={onClose}
                      onMouseEnter={onOpen}
                      minW="352px"
                      maxH="700px"
                      overflowY="auto"
                    >
                      <PopoverArrow />
                      <PopoverHeader fontWeight="semibold" textAlign={"center"}>
                        {item}
                      </PopoverHeader>
                      <PopoverCloseButton marginTop="1px" />
                      <PopoverBody>
                        <Flex flexDirection="column" alignItems="flex-start" justifyContent="flex-start">
                          {menufilho.map((filho, idx) => {
                            if (filho.menupai == item && filho.menufilho != "Pedido de brinde") {
                              return (
                                <Button
                                  key={idx}
                                  as={Link}
                                  // href={filho.menulink}
                                  to={filho.menulink}
                                  mb={2}
                                  mr={2}
                                  variant="ghost"
                                  colorScheme="blue"
                                  size="sm"
                                  borderRadius={0}
                                  width="100%"
                                >
                                  {filho.menufilho === "Orçamento de brinde"
                                    ? "Novo Orçamento de Brinde"
                                    : filho.menufilho}
                                </Button>
                              );
                            }
                          })}
                        </Flex>
                      </PopoverBody>
                    </PopoverContent>
                  </Portal>
                </>
              )}
            </Popover>
          );
        }
      })}
    </>
  );
};

export default ComponentCenterListMenu;
